document.addEventListener("click", function (event) {
  const button = event.target.closest(".quick-add__button");

  if (!button) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const handle = button.dataset.handle;
  const path = `/products/${handle}`;

  const url =
    typeof buildPreviewAwareUrl === "function"
      ? buildPreviewAwareUrl(path, {
          view: "quickview"
        })
      : `${path}?view=quickview`;

  if (!handle) {
    console.log("No handle found");
    return;
  }

  fetch(url)
    .then(response => response.json())
    .then(data => {
      let styleNumber = "";

      (data.tags || []).forEach(tag => {
        if (tag.includes("style-number:")) {
          styleNumber = tag.split(":")[1];
        }
      });

      if (styleNumber) {
        loadSiblings(styleNumber).then(() => {
          initQuickView(data, styleNumber);
        });
      } else {
        initQuickView(data, "");
      }
    })
    .catch(error => {
      console.log("Fetch error:", error);
    });
});

let siblings = [];

function extractTag(tags, prefix) {
  let value = "";

  (tags || []).forEach(tag => {
    if (
      tag
        .toLowerCase()
        .includes(prefix + ":")
    ) {
      value = tag.split(":")[1].trim();
    }
  });

  return value;
}

function getProductImages(product, options = {}) {
  let images = product.media || [];

  if (!images.length && product.images) {
    images = product.images.map(image => ({
      src: image,
      alt: ""
    }));
  }

  if (!images.length) return [];

  // Remove SWATCH images from the main gallery.
  images = images.filter(image => {
    const imageUrl =
      typeof image === "string"
        ? image
        : image.src ||
          image.url ||
          (
            image.preview_image &&
            image.preview_image.src
          ) ||
          "";

    return !imageUrl
      .toUpperCase()
      .includes("SWATCH");
  });

  const filteredImages = images.filter(image => {
    const alt = (image.alt || "").toLowerCase();

    return (
      (
        options.color &&
        alt.includes(
          options.color.toLowerCase()
        )
      ) ||
      (
        options.fit &&
        alt.includes(
          options.fit.toLowerCase()
        )
      )
    );
  });

  return filteredImages.length
    ? filteredImages
    : images;
}

function setupQuickViewSlider(root) {
  if (!root) return;

  const productImages =
    root.querySelector("product-images");

  const slider =
    root.querySelector(".product__slides");

  const slides = slider
    ? [
        ...slider.querySelectorAll(
          "[data-slide]"
        )
      ]
    : [];

  if (!slider || !slides.length) return;

  const sliderKey = productImages
    ? (
        productImages.getAttribute(
          "data-active-media"
        ) || String(slides.length)
      )
    : String(slides.length);

  const previousKey =
    slider.dataset.quickViewSliderKey;

  if (previousKey !== sliderKey) {
    slider.dataset.quickViewSlide = "0";
    slider.dataset.quickViewSliderKey =
      sliderKey;
  }

  let currentIndex = Number(
    slider.dataset.quickViewSlide || 0
  );

  currentIndex = Math.max(
    0,
    Math.min(
      currentIndex,
      slides.length - 1
    )
  );

  const oldControls = slider.querySelector(
    ".quick-view-slider__controls"
  );

  if (oldControls) {
    oldControls.remove();
  }

  slider.style.position = "relative";
  slider.style.overflow = "hidden";

  const controls =
    document.createElement("div");

  const previousButton =
    document.createElement("button");

  const nextButton =
    document.createElement("button");

  const counter =
    document.createElement("span");

  controls.className =
    "quick-view-slider__controls";

  controls.style.position = "absolute";
  controls.style.inset = "0";
  controls.style.zIndex = "5";
  controls.style.pointerEvents = "none";

  const setButtonStyles = (
    button,
    side
  ) => {
    button.type = "button";
    button.style.position = "absolute";
    button.style.top = "50%";
    button.style[side] = "12px";
    button.style.transform =
      "translateY(-50%)";
    button.style.width = "40px";
    button.style.height = "40px";
    button.style.padding = "0";
    button.style.border =
      "1px solid rgba(16, 42, 92, 0.25)";
    button.style.borderRadius = "50%";
    button.style.background =
      "rgba(255, 255, 255, 0.92)";
    button.style.color = "#102a5c";
    button.style.fontSize = "30px";
    button.style.lineHeight = "34px";
    button.style.cursor = "pointer";
    button.style.pointerEvents = "auto";
    button.style.display = "flex";
    button.style.alignItems = "center";
    button.style.justifyContent = "center";
    button.style.boxShadow =
      "0 2px 8px rgba(0, 0, 0, 0.12)";
  };

  setButtonStyles(
    previousButton,
    "left"
  );

  setButtonStyles(
    nextButton,
    "right"
  );

  previousButton.className =
    "quick-view-slider__arrow quick-view-slider__arrow--previous";

  previousButton.setAttribute(
    "aria-label",
    "Previous product image"
  );

  previousButton.innerHTML = "&#8249;";

  nextButton.className =
    "quick-view-slider__arrow quick-view-slider__arrow--next";

  nextButton.setAttribute(
    "aria-label",
    "Next product image"
  );

  nextButton.innerHTML = "&#8250;";

  counter.className =
    "quick-view-slider__counter";

  counter.style.position = "absolute";
  counter.style.left = "50%";
  counter.style.bottom = "12px";
  counter.style.transform =
    "translateX(-50%)";
  counter.style.padding = "4px 9px";
  counter.style.borderRadius = "20px";
  counter.style.background =
    "rgba(255, 255, 255, 0.9)";
  counter.style.color = "#102a5c";
  counter.style.fontSize = "12px";
  counter.style.lineHeight = "1.2";
  counter.style.pointerEvents = "none";

  const renderSlide = index => {
    currentIndex = Math.max(
      0,
      Math.min(
        index,
        slides.length - 1
      )
    );

    slider.dataset.quickViewSlide =
      String(currentIndex);

    slides.forEach(
      (slide, slideIndex) => {
        const active =
          slideIndex === currentIndex;

        slide.hidden = !active;

        slide.style.display = active
          ? "block"
          : "none";

        slide.classList.toggle(
          "media--active",
          active
        );

        slide.classList.toggle(
          "media--hidden",
          !active
        );

        slide.setAttribute(
          "aria-hidden",
          active ? "false" : "true"
        );
      }
    );

    previousButton.disabled =
      currentIndex === 0;

    nextButton.disabled =
      currentIndex ===
      slides.length - 1;

    previousButton.style.opacity =
      previousButton.disabled
        ? "0.35"
        : "1";

    nextButton.style.opacity =
      nextButton.disabled
        ? "0.35"
        : "1";

    previousButton.style.cursor =
      previousButton.disabled
        ? "default"
        : "pointer";

    nextButton.style.cursor =
      nextButton.disabled
        ? "default"
        : "pointer";

    counter.textContent =
      `${currentIndex + 1} / ${slides.length}`;
  };

  previousButton.addEventListener(
    "click",
    event => {
      event.preventDefault();
      event.stopPropagation();

      renderSlide(currentIndex - 1);
    }
  );

  nextButton.addEventListener(
    "click",
    event => {
      event.preventDefault();
      event.stopPropagation();

      renderSlide(currentIndex + 1);
    }
  );

  if (slider._quickViewTouchStart) {
    slider.removeEventListener(
      "touchstart",
      slider._quickViewTouchStart
    );

    slider.removeEventListener(
      "touchend",
      slider._quickViewTouchEnd
    );
  }

  let touchStartX = null;

  slider._quickViewTouchStart = event => {
    touchStartX =
      event.changedTouches &&
      event.changedTouches[0]
        ? event.changedTouches[0].clientX
        : null;
  };

  slider._quickViewTouchEnd = event => {
    if (
      touchStartX === null ||
      !event.changedTouches ||
      !event.changedTouches[0]
    ) {
      return;
    }

    const distance =
      event.changedTouches[0].clientX -
      touchStartX;

    if (Math.abs(distance) >= 40) {
      renderSlide(
        distance < 0
          ? currentIndex + 1
          : currentIndex - 1
      );
    }

    touchStartX = null;
  };

  slider.addEventListener(
    "touchstart",
    slider._quickViewTouchStart,
    {
      passive: true
    }
  );

  slider.addEventListener(
    "touchend",
    slider._quickViewTouchEnd,
    {
      passive: true
    }
  );

  if (slides.length > 1) {
    controls.append(
      previousButton,
      nextButton,
      counter
    );

    slider.appendChild(controls);
  }

  renderSlide(currentIndex);
}


function setupQuickViewPdpLink(root, instance) {
  if (!root || !instance) return;

  const descriptionBlock = root.querySelector(
    ".prod-info__description"
  );

  if (!descriptionBlock) return;

  const oldPdpButton = root.querySelector(
    ".quick-view-pdp-link"
  );

  if (oldPdpButton) {
    oldPdpButton.remove();
  }

  const oldSeeMoreLink = root.querySelector(
    ".quick-view-see-more"
  );

  if (oldSeeMoreLink) {
    oldSeeMoreLink.remove();
  }

  const seeMoreLink =
    document.createElement("a");

  seeMoreLink.className =
    "quick-view-see-more";

  seeMoreLink.textContent = "View Full Details";

  seeMoreLink.style.cssText = `
    display: table;
    margin: 4px 0 0 auto;
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
  `;

  descriptionBlock.insertAdjacentElement(
  "afterend",
  seeMoreLink
);

  const updateSelectedVariantUrl = () => {
    const handle =
      instance.currentProduct &&
      instance.currentProduct.handle;

    const variantId =
      instance.currentVariant &&
      instance.currentVariant.id;

    seeMoreLink.href = handle
      ? `/products/${handle}${
          variantId
            ? `?variant=${variantId}`
            : ""
        }`
      : "#";
  };

  updateSelectedVariantUrl();
  seeMoreLink.onclick = updateSelectedVariantUrl;
}



function loadSiblings(styleNumber) {
  const path =
    `/collections/all/style-number-${encodeURIComponent(
      styleNumber
    )}`;

  const url =
    typeof buildPreviewAwareUrl === "function"
      ? buildPreviewAwareUrl(path, {
          view: "data"
        })
      : `${path}?view=data`;

  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(
          "Unable to load sibling products"
        );
      }

      return response.json();
    })
    .then(products => {
      siblings = products.map(product => {
        const tags = product.tags || [];

        const colorOverride =
          extractTag(
            tags,
            "color-override"
          );

        const color =
          colorOverride ||
          extractTag(tags, "color") ||
          (
            product.variants &&
            product.variants[0]
              ? product.variants[0].option1
              : ""
          );

        const fit =
          extractTag(tags, "fit");

        const allImages = [
          ...(product.images || []),
          ...(product.media || [])
        ];

        const swatchItem =
          allImages.find(item => {
            const imageUrl =
              typeof item === "string"
                ? item
                : item.src ||
                  item.url ||
                  (
                    item.preview_image &&
                    item.preview_image.src
                  ) ||
                  "";

            return imageUrl
              .toUpperCase()
              .includes("SWATCH");
          });

        const swatchImage =
          typeof swatchItem === "string"
            ? swatchItem
            : swatchItem
              ? swatchItem.src ||
                swatchItem.url ||
                (
                  swatchItem.preview_image &&
                  swatchItem.preview_image.src
                ) ||
                ""
              : "";

        return {
          ...product,
          color,
          fit,
          swatchImage
        };
      });
    })
    .catch(error => {
      console.error(
        "Sibling products error:",
        error
      );

      siblings = [];
    });
}

function initQuickView(
  data,
  styleNumber
) {
  if (!data || !data.product) return;

  if (window.quickViewInstance) {
    window.quickViewInstance.$destroy();
  }

  const product = data.product;
  const tags = data.tags || [];

  const selectedColor =
    extractTag(
      tags,
      "color-override"
    ) ||
    extractTag(
      tags,
      "color"
    );

  const selectedFit =
    extractTag(tags, "fit");

  const firstVariant =
    product.variants[0];

  const colorOptions = [
    ...new Set(
      siblings
        .map(product => product.color)
        .filter(Boolean)
    )
  ];

  const fitOptions = [
    ...new Set(
      siblings
        .map(product => product.fit)
        .filter(Boolean)
    )
  ];

  const regularFitIndex =
    fitOptions.indexOf("Regular Fit");

  if (regularFitIndex > 0) {
    fitOptions.push(
      ...fitOptions.splice(
        0,
        regularFitIndex
      )
    );
  }

  window.quickViewInstance = new Vue({
    el: "#quick-view-app",

    delimiters: ["[[", "]]"],

    data: {
      styleNumber,
      imageKey: 0,
      currentProduct: product,
      currentVariant: firstVariant,
      optionDefinitions:
        data.options || [],

      currentOptions: {
        color:
          selectedColor ||
          firstVariant.option1,

        fit: selectedFit,
        dm: "",
        size: ""
      },

      colorOptions,
      fitOptions,

      description:
        data.description ||
        product.description,

      images: getProductImages(
        product,
        {
          color: selectedColor,
          fit: selectedFit
        }
      ),

      quantity: 1,
      addButtonText: "Select a size",
      canAddToCart: false
    },

    computed: {
      formattedPrice() {
        return this.currentVariant
          ? this.formatMoney(
              this.currentVariant.price
            )
          : "";
      },

      dmOptions() {
        const selectedSize =
          this.currentOptions.size;

        const definition =
          this.optionDefinitions.find(
            option =>
              option.name.toLowerCase() ===
              "dm"
          );

        const orderedValues =
          definition &&
          definition.values
            ? definition.values
            : [
                ...new Set(
                  this.currentProduct
                    .variants
                    .map(
                      variant =>
                        variant.option2
                    )
                )
              ].filter(Boolean);

        return orderedValues
          .filter(
            value =>
              value &&
              value.toLowerCase() !== "na"
          )
          .map(value => ({
            value,

            inStock:
              this.currentProduct
                .variants
                .some(
                  variant =>
                    variant.option2 ===
                      value &&
                    (
                      !selectedSize ||
                      variant.option3 ===
                        selectedSize
                    ) &&
                    variant.available
                )
          }));
      },

      sizeOptions() {
        const selectedDM =
          this.currentOptions.dm;

        const definition =
          this.optionDefinitions.find(
            option =>
              option.name.toLowerCase() ===
              "size"
          );

        const orderedValues =
          definition &&
          definition.values
            ? definition.values
            : [
                ...new Set(
                  this.currentProduct
                    .variants
                    .map(
                      variant =>
                        variant.option3
                    )
                )
              ].filter(Boolean);

        return orderedValues
          .filter(
            value =>
              value &&
              value.toLowerCase() !== "na"
          )
          .map(value => ({
            value,

            inStock:
              this.currentProduct
                .variants
                .some(
                  variant =>
                    variant.option3 ===
                      value &&
                    (
                      !selectedDM ||
                      variant.option2 ===
                        selectedDM
                    ) &&
                    variant.available
                )
          }));
      }
    },

    mounted() {
      this.safeInitImages();

      setTimeout(() => {
        this.safeInitImages();
      }, 300);
    },

    methods: {
      formatMoney(price) {
        if (!price) return "";

        if (
          typeof Shopify !== "undefined"
        ) {
          return Shopify.formatMoney(
            price,
            Shopify.money_format
          )
            .replace(/\.00/g, "")
            .replace(
              /(\.\d{1,2})/g,
              ""
            );
        }

        return Math.floor(price / 100);
      },

      checkSelections() {
        const hasDMOptions =
          this.dmOptions &&
          this.dmOptions.length > 0;

        const hasFitOptions =
          this.fitOptions &&
          this.fitOptions.length > 0;

        const hasSizeOptions =
          this.sizeOptions &&
          this.sizeOptions.length > 0;

        const dmSelected =
          !hasDMOptions ||
          !!this.currentOptions.dm;

        const fitSelected =
          !hasFitOptions ||
          !!this.currentOptions.fit;

        const sizeSelected =
          !hasSizeOptions ||
          !!this.currentOptions.size;

        if (
          dmSelected &&
          fitSelected &&
          sizeSelected &&
          this.currentVariant &&
          this.currentVariant.available
        ) {
          this.addButtonText =
            "Add to Cart";

          this.canAddToCart = true;
        } else {
          this.addButtonText =
            "Select a size";

          this.canAddToCart = false;
        }
      },

      updateVariant() {
        const selectedDM =
          this.currentOptions.dm;

        const selectedSize =
          this.currentOptions.size;

        const hasDMOptions =
          this.dmOptions &&
          this.dmOptions.length > 0;

        const matchingVariant =
          this.currentProduct
            .variants
            .find(variant => {
              const sizeMatches =
                !selectedSize ||
                variant.option3 ===
                  selectedSize;

              const dmMatches =
                !hasDMOptions ||
                variant.option2 ===
                  selectedDM;

              return (
                sizeMatches &&
                dmMatches
              );
            });

        this.currentVariant =
          matchingVariant ||
          this.currentProduct
            .variants[0] ||
          null;

        this.checkSelections();

        if (
          this.currentVariant &&
          this.currentVariant
            .featured_image
        ) {
          this.images =
            getProductImages(
              {
                media: [
                  this.currentVariant
                    .featured_image
                ]
              },
              this.currentOptions
            );

          this.imageKey++;

          this.$nextTick(() => {
            this.safeInitImages();
          });
        }
      },

      selectOption(type, value) {
        let exactProduct = null;

        if (type === "color") {
          const sameFitProduct =
            this.getExactProduct(
              value,
              this.currentOptions.fit
            );

          exactProduct =
            sameFitProduct &&
            sameFitProduct.variants.some(
              variant => variant.available
            )
              ? sameFitProduct
              : siblings.find(
                  product =>
                    product.color === value &&
                    product.variants.some(
                      variant =>
                        variant.available
                    )
                );

          if (!exactProduct) return;

          this.currentOptions.color =
            value;

          this.currentOptions.fit =
            exactProduct.fit;
        } else if (type === "fit") {
          if (
            !this.isFitAvailable(value)
          ) {
            return;
          }

          this.currentOptions.fit =
            value;

          exactProduct =
            this.getExactProduct(
              this.currentOptions.color,
              value
            );
        } else {
          this.currentOptions[type] =
            value;
        }

        if (
          type === "color" ||
          type === "fit"
        ) {
          exactProduct =
            exactProduct ||
            this.getExactProduct(
              this.currentOptions.color,
              this.currentOptions.fit
            );

          if (
            !exactProduct ||
            !exactProduct.variants.some(
              variant =>
                variant.available
            )
          ) {
            this.currentVariant = null;
            this.checkSelections();
            return;
          }

          const productPath =
            `/products/${exactProduct.handle}`;

          const productUrl =
            typeof buildPreviewAwareUrl ===
            "function"
              ? buildPreviewAwareUrl(
                  productPath,
                  {
                    view: "quickview"
                  }
                )
              : `${productPath}?view=quickview`;

          fetch(productUrl)
            .then(response => {
              if (!response.ok) {
                throw new Error(
                  "Unable to load selected product"
                );
              }

              return response.json();
            })
            .then(productData => {
              const selectedProduct =
                productData.product;

              this.currentProduct =
                selectedProduct;

              this.description =
                productData.description ||
                selectedProduct.description ||
                "";

              this.optionDefinitions =
                productData.options ||
                this.optionDefinitions;

              const selectedDM =
                this.currentOptions.dm;

              const selectedSize =
                this.currentOptions.size;

              this.currentProduct.media =
                (
                  selectedProduct.images ||
                  []
                ).map(image => ({
                  src: image,
                  alt: ""
                }));

              this.images =
                getProductImages(
                  this.currentProduct,
                  this.currentOptions
                );

              this.imageKey++;

              this.$nextTick(() => {
                this.safeInitImages();
              });

              const matchingVariant =
                selectedProduct
                  .variants
                  .find(
                    variant =>
                      variant.option2 ===
                        selectedDM &&
                      variant.option3 ===
                        selectedSize &&
                      variant.available
                  );

              if (matchingVariant) {
                this.currentOptions.dm =
                  selectedDM;

                this.currentOptions.size =
                  selectedSize;

                this.currentVariant =
                  matchingVariant;
              } else {
                this.currentOptions.dm = "";
                this.currentOptions.size = "";

                this.currentVariant =
                  selectedProduct
                    .variants[0] ||
                  null;
              }

              this.checkSelections();
            })
            .catch(error => {
              console.error(
                "Quick View product error:",
                error
              );

              this.currentOptions.dm = "";
              this.currentOptions.size = "";
              this.currentVariant = null;

              this.checkSelections();
            });
        }

        if (
          type === "dm" ||
          type === "size"
        ) {
          this.updateVariant();
        }

        this.checkSelections();
      },

      addToCart() {
        if (
          !this.currentVariant ||
          !this.currentVariant.available
        ) {
          return;
        }

        fetch("/cart/add.js", {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json"
          },

          body: JSON.stringify({
            id: this.currentVariant.id,
            quantity: this.quantity,

            properties: {
              Fit:
                this.currentOptions.fit,

              "Style #":
                this.currentVariant.sku
            }
          })
        }).then(() => {
          document.dispatchEvent(
            new CustomEvent(
              "theme:cart:refresh"
            )
          );
        });
      },

      safeInitImages() {
        this.$nextTick(() => {
          /*
           * Vue replaces the original
           * #quick-view-app mounting element,
           * so this.$el must be used here.
           */
          const quickViewRoot = this.$el;

          if (!quickViewRoot) return;

          const productImages =
            quickViewRoot.querySelector(
              "product-images"
            );

          if (productImages) {
            try {
              if (
                productImages.slider &&
                typeof productImages
                  .slider
                  .destroy === "function"
              ) {
                productImages
                  .slider
                  .destroy();
              }

              if (
                typeof productImages.init ===
                "function"
              ) {
                productImages.init();
              }

              if (
                window.theme &&
                typeof window.theme
                  .initSliders ===
                  "function"
              ) {
                window.theme
                  .initSliders();
              }
            } catch (error) {
              console.log(
                "Slider init error",
                error
              );
            }
          }

          setupQuickViewSlider(
            quickViewRoot
          );

          setupQuickViewPdpLink(
            quickViewRoot,
            this
          );
        });
      },

      getExactProduct(color, fit) {
        return siblings.find(
          product =>
            product.color === color &&
            product.fit === fit
        );
      },

      getColorSwatch(color) {
        const exactProduct =
          this.getExactProduct(
            color,
            this.currentOptions.fit
          );

        const colorProduct =
          exactProduct ||
          siblings.find(
            product =>
              product.color === color
          );

        if (!colorProduct) return "";

        return (
          colorProduct.swatchImage ||
          colorProduct.image ||
          ""
        );
      },

      isColorAvailable(color) {
        return siblings.some(
          product =>
            product.color === color &&
            product.variants.some(
              variant =>
                variant.available
            )
        );
      },

      isFitAvailable(fit) {
        const exactProduct =
          this.getExactProduct(
            this.currentOptions.color,
            fit
          );

        return (
          !!exactProduct &&
          exactProduct.variants.some(
            variant =>
              variant.available
          )
        );
      }
    },

    template: `
<div class="quick-view-inner">

  <!-- IMAGES -->
  <product-images
    class="product-quick-add__images product__images product__images--thumbs product__images--mobile-thumbs"
    :data-active-media="'quickview-' + imageKey"
    data-fader-desktop
  >

    <div
      class="product__slides is-animated"
      data-product-media-list
      data-animation="drawer-images-fade"
      data-animation-duration="500"
      data-animation-delay="200"
    >

      <div
        v-for="(img, index) in images"
        :key="imageKey + '-' + index"
        class="product__slide"
        :class="
          index === 0
            ? 'media--active'
            : 'media--hidden'
        "
        :data-media-id="'quickview-' + index"
        data-type="image"
        data-slide
      >

        <div
          class="product__photo"
          tabindex="0"
        >

          <figure
            class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
          >

            <a
              :href="'/products/' + currentProduct.handle"
            >
              <img
                :src="
                  img.src ||
                  (
                    img.preview_image &&
                    img.preview_image.src
                  )
                "
                :alt="img.alt || ''"
                loading="lazy"
              />
            </a>

          </figure>

        </div>

      </div>

    </div>

  </product-images>

  <!-- TITLE -->
  <div
    class="product__block product__head block-padding is-animated"
  >
    <div class="product__title__wrapper">
      <h1
        class="product__title heading-small"
      >
        <a
          :href="'/products/' + currentProduct.handle"
        >
          <span>
            [[
              currentProduct.title
                .split('|')
                .pop()
                .trim()
            ]]
          </span>
        </a>
      </h1>
    </div>
  </div>

  <!-- PRICE -->
  <div
    class="product__block block-padding is-animated"
  >
    <div class="product__price__wrap">
      <div
        class="price product__price price--large"
      >
        <div class="price__container">
          <div class="price__regular">
            <span
              class="price-item price-item--regular"
            >
              [[ formattedPrice ]]
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- COLOR -->
  <div class="prod-info__option">

    <div class="prod-info__option__header">
      <span class="label">
        Color
      </span>

      <span>
        / [[ currentOptions.color ]]
      </span>
    </div>

    <div class="prod-info__option__colors">

      <div
        v-for="color in colorOptions"
        :key="'color-' + color"
        :class="[
          'color-swatch',

          currentOptions.color === color
            ? 'selected'
            : '',

          !isColorAvailable(color)
            ? 'soldout'
            : ''
        ]"
      >

        <button
          type="button"
          :disabled="
            !isColorAvailable(color)
          "
          @click="
            selectOption(
              'color',
              color
            )
          "
          :aria-label="color"
          :style="{
            backgroundImage:
              'url(' +
              getColorSwatch(color) +
              ')'
          }"
        ></button>

      </div>

    </div>
  </div>

  <!-- FIT -->
  <div
    class="prod-info__option"
    v-if="fitOptions.length"
  >

    <div class="prod-info__option__header">
      <span class="label">
        Fit
      </span>
    </div>

    <div class="prod-info__option__options">

      <button
        v-for="fit in fitOptions"
        :key="'fit-' + fit"
        type="button"
        @click="
          selectOption(
            'fit',
            fit
          )
        "
        :class="[
          'chip',

          currentOptions.fit === fit
            ? 'selected'
            : '',

          !isFitAvailable(fit)
            ? 'soldout'
            : ''
        ]"
      >
        [[ fit ]]
      </button>

    </div>
  </div>

  <!-- NECK -->
  <div
    class="prod-info__option"
    v-if="dmOptions.length"
  >

    <div class="prod-info__option__header">
      <span class="label">
        Neck
      </span>
    </div>

    <div class="prod-info__option__options">

      <button
        v-for="dm in dmOptions"
        :key="'dm-' + dm.value"
        type="button"
        @click="
          selectOption(
            'dm',
            dm.value
          )
        "
        :class="[
          'chip',

          currentOptions.dm === dm.value
            ? 'selected'
            : '',

          !dm.inStock
            ? 'soldout'
            : ''
        ]"
      >
        [[ dm.value ]]
      </button>

    </div>
  </div>

  <!-- SLEEVE -->
  <div
    class="prod-info__option"
    v-if="sizeOptions.length"
  >

    <div class="prod-info__option__header">
      <span class="label">
        Sleeve
      </span>
    </div>

    <div class="prod-info__option__options">

      <button
        v-for="size in sizeOptions"
        :key="'size-' + size.value"
        type="button"
        @click="
          selectOption(
            'size',
            size.value
          )
        "
        :class="[
          'chip',

          currentOptions.size === size.value
            ? 'selected'
            : '',

          !size.inStock
            ? 'soldout'
            : ''
        ]"
      >
        [[ size.value ]]
      </button>

    </div>
  </div>

  <!-- DESCRIPTION -->
  <div
    class="prod-info__description"
    v-if="description"
  >
    <div v-html="description"></div>
  </div>

  <!-- ADD TO CART -->
  <div class="product-form__buttons">
    <button
      type="button"
      class="btn btn--full"
      :disabled="!canAddToCart"
      @click="addToCart"
    >
      [[ addButtonText ]]
    </button>
  </div>

</div>
`
  });
}